import styled from "styled-components"

export const Container = styled.div`
    text-align: center;
    font-size: 16px;
`

export const SocialButton = styled.button`
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: none;
    color: white;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.2s;
    background-color: #1976d2; /* Default blue, can be overridden */

    &:hover {
        transform: scale(1.1);
    }

    &:focus {
        outline: 2px solid #fff;
        outline-offset: 2px;
    }

    /* Allow style prop to override background color */
    ${(props) =>
        props.style &&
        `
        background-color: ${props.style.backgroundColor || "#1976d2"};
    `}
`
